import { gql } from '@apollo/client';

const reelViewItem = gql`
  fragment ReelViewItem on ReelView {
    id
    hasCables
    totalAssignedLength
  }
`;

export const reelFragments = {
  reelItem: gql`
    ${reelViewItem}
    fragment ReelItem on Reel {
      id
      projectId
      cableCodeId
      tag
      totalLength
      usedLength
      badLength
      deliveryDate
      serialNumber
      unit
      location
      misc1
      misc2
      misc3
      misc4
      misc5
      misc6
      ownerId
      updatedBy
      updatedByUser {
        id
        nameFirst
        nameLast
        nameMiddle
        userAccountPhoto {
          id
          photo
        }
      }
      updatedTime
      cableCode {
        id
        tag
      }
      reelView {
        ...ReelViewItem
      }
    }
  `,
};
export const SEARCH_REEL = gql`
  ${reelFragments.reelItem}
  query SearchReels($searchInput: SearchInput) {
    searchReels(searchInput: $searchInput) {
      items {
        ...ReelItem
      }
    }
  }
`;

export const CREATE_REEL = gql`
  ${reelFragments.reelItem}
  mutation CreateReel($createReelInput: CreateReelInput!) {
    createReel(createReelInput: $createReelInput) {
      reel {
        ...ReelItem
      }
      errors
    }
  }
`;

export const DELETE_REEL = gql`
  mutation DeleteReel($deleteReelInput: DeleteReelInput!) {
    deleteReel(deleteReelInput: $deleteReelInput) {
      id
      errors
    }
  }
`;

export const UPDATE_REEL = gql`
  ${reelFragments.reelItem}
  mutation UpdateReel($updateReelInput: UpdateReelInput!) {
    updateReel(updateReelInput: $updateReelInput) {
      reel {
        ...ReelItem
      }
      errors
    }
  }
`;

export const UPDATE_REELS = gql`
  ${reelFragments.reelItem}
  mutation UpdateReels($updateReelsInput: [UpdateReelInput!]!) {
    updateReels(updateReelsInput: $updateReelsInput) {
      reels {
        ...ReelItem
      }
      infos {
        tag
        messageKeys
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const GET_REEL_BY_ID = gql`
  ${reelFragments.reelItem}
  query ReelById($id: ID!) {
    reelById(id: $id) {
      ...ReelItem
    }
  }
`;

export const SEARCH_REEL_CABLES = gql`
  query SearchCableReels($searchInput: SearchInput) {
    searchCableReels(searchInput: $searchInput) {
      items {
        assignedLength
        cutLength
        id
        cableId
        cable {
          tag
          unit
          facility
          engrLength
          numberOfCables
        }
      }
    }
  }
`;

export const GET_REEL_VIEW_STATS = gql`
  ${reelViewItem}
  query GetReelViewStats($id: ID!) {
    reelById(id: $id) {
      id
      reelView {
        ...ReelViewItem
      }
    }
  }
`;
